// extracted by mini-css-extract-plugin
module.exports = {"overlay":"HoloFx_overlay__py8zG","holoFx":"HoloFx_holoFx__m7dNL","burn":"HoloFx_burn__wxdHf","shine":"HoloFx_shine__LERCh","texture":"HoloFx_texture__JucUA"};